import { DebtQuote } from '../interfaces/services/get-debt-columns-service.interface';

export const getDebtQuoteKey = (item: DebtQuote): string =>
  item.key ??
  `${item.articulo}-${item.superpoliza}-${item.suplemento}-${item.asegurado}`;

export const applyCheckboxChangeToRow = (
  item: DebtQuote,
  column: string,
  checked: boolean,
  checkboxList: string[]
): DebtQuote => {
  const columnIndex = checkboxList.indexOf(column);
  const updatedItem = { ...item, [column]: checked } as DebtQuote;

  if (checked) {
    for (let i = 0; i < columnIndex; i++) {
      (updatedItem as any)[checkboxList[i]] = true;
    }
  } else {
    for (let i = columnIndex + 1; i < checkboxList.length; i++) {
      (updatedItem as any)[checkboxList[i]] = false;
    }
  }

  return updatedItem;
};

export const rowHasCheckboxSelection = (row: DebtQuote): boolean =>
  !!(
    row.deudaAnteriorOPT ||
    row.quincenaAnteriorOPT ||
    row.quincenaActualOPT ||
    row.quincenaSiguienteOPT ||
    row.quincenaPosteriorOPT ||
    row.saldoOPT ||
    row.pagoContadoOPT
  );
